import { Outlet, useRouter } from '@tanstack/react-router';
import { RouterProvider } from 'react-aria-components';

/** React Aria links (`href`) navigate through the router, not a full page load. */
export function AriaRouter() {
   const router = useRouter();
   return (
      <RouterProvider navigate={(href) => router.history.push(href)}>
         <Outlet />
      </RouterProvider>
   );
}
